var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#DFF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 33.6H15a3 3 0 01-3-3v-12a3 3 0 013-3h18a3 3 0 013 3v12a3 3 0 01-3 3zm-19-10v7a1 1 0 001 1h18a1 1 0 001-1v-7H14zm1-6a1 1 0 00-1 1v3h20v-3a1 1 0 00-1-1H15z",
    fill: "#0090FF"
  })));
}
export default SvgPaymentDetails;